import React, { useState } from 'react';
import { RouteComponentProps } from '@reach/router';
import { DateTime } from 'luxon';
import { CommonCard, TotalMessageChart, AccountPerformanceTable } from './particles';
import { Grid, Box, Stack } from '@mui/material';

import { useCompanyEngagement, useTotalUsers } from '@api';
import { EngagementOverTime, DashboardHeader } from '@organisms';

const NegotiatorDashboard: React.FC<RouteComponentProps> = () => {
  const [start, setStart] = useState<Date>(DateTime.local().minus({ days: 6 }).startOf('day').toJSDate());
  const [end, setEnd] = useState<Date>(DateTime.local().endOf('day').toJSDate());

  const startDate = DateTime.fromJSDate(start).toISO({
    suppressMilliseconds: true,
    includeOffset: false
  });
  const endDate = DateTime.fromJSDate(end).toISO({
    suppressMilliseconds: true,
    includeOffset: false
  });

  const { data: companyEngagementResp, isFetching: loadingCompanyEngagement } =
    useCompanyEngagement({ from: startDate, to: endDate });
  const { data: totalUsersResp, isFetching: loadingTotalUsers } = useTotalUsers({});

  const companyEngagement: Engagement[] = companyEngagementResp?.data ?? [];
  const activeInactive: ActiveInactive = totalUsersResp?.data?.data?.total ?? {
    active: 0,
    inactive: 0
  };

  return (
    <Stack sx={{ m: 2 }}>
      <Box sx={{ mt: 1, mb: 2 }}>
        <DashboardHeader
          csvDownload={true}
          start={start}
          end={end}
          onSelectRange={(start, end) => {
            setStart(start);
            setEnd(end);
          }}
        />
      </Box>

      <CommonCard
        loading={loadingCompanyEngagement || loadingTotalUsers}
        users={activeInactive.active + activeInactive.inactive}
        accounts={companyEngagement.length}
        actives={activeInactive.active ?? 0}
      />

      <Grid container columnSpacing={2} mt={2}>
        <Grid md={12} sm={12} item>
          <EngagementOverTime start={start} end={end} />
        </Grid>
      </Grid>
      <Box sx={{ mt: 2, mb: 2 }}>
        <AccountPerformanceTable start={start} end={end} />
      </Box>
      <Box sx={{ mt: 2, mb: 2 }}>
        <TotalMessageChart
          loading={loadingCompanyEngagement}
          companyEngagement={companyEngagement}
        />
      </Box>
    </Stack>
  );
};

export default NegotiatorDashboard;
